import { useEffect, useRef } from "react";

import { createWebDraggableSheet } from "~/ui/base/WebDraggableSheet.tsx";

type Effect = "bounce" | "still";

export const WebShowPictureSheet = createWebDraggableSheet<{
  effect: Effect;
  title: string;
  videoUrl: string;
}>(({ context, titleId }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (context.effect === "still") {
      video.currentTime = video.duration / 2 || 0;
      video.pause();
    } else {
      video.loop = true;
      void video.play();
    }
  }, [context.effect]);

  const handleLoaded = () => {
    const video = videoRef.current;
    if (!video) return;

    if (context.effect === "still") {
      video.currentTime = video.duration / 2 || 0;
      video.pause();
    } else {
      video.loop = true;
      void video.play();
    }
  };

  const handleTimeUpdate = () => {
    if (context.effect !== "bounce") return;
    const video = videoRef.current;
    if (!video) return;

    if (video.currentTime >= video.duration - 0.05) {
      video.playbackRate = -1;
    } else if (video.currentTime <= 0.05 && video.playbackRate < 0) {
      video.playbackRate = 1;
    }
  };

  const handleEnded = () => {
    const video = videoRef.current;
    if (!video) return;
    video.currentTime = 0;
    void video.play();
  };

  return (
    <div data-testid="사진 보기">
      <h1
        className="text-lg font-semibold text-zinc-800 dark:text-zinc-100"
        id={titleId}
      >
        {context.title}
      </h1>
      <div className="h-6" />
      <div className="aspect-square w-full overflow-hidden rounded-2xl bg-black">
        <video
          className="size-full object-cover"
          muted
          onEnded={handleEnded}
          onLoadedData={handleLoaded}
          onTimeUpdate={
            context.effect === "bounce" ? handleTimeUpdate : undefined
          }
          playsInline
          ref={videoRef}
          src={context.videoUrl}
        />
      </div>
    </div>
  );
});
